import { Button } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';

export const BtnSubmitStyled = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.global.white,
  backgroundColor: theme.palette.secondary.main,
  width: 200,
  height: 54,
  '&:hover': {
    backgroundColor: alpha(theme.palette.secondary.main, 0.7),
  },
}));

export const BtnCancelStyled = styled(Button)(({ theme }) => ({
  fontWeight: 'bold',
  color: theme.palette.global.gray,
  backgroundColor: '#ccc',
  width: 200,
  height: 54,
}));

export const LinksStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
  marginBottom: 16,
  cursor: 'pointer',
  '&:hover': {
    color: theme.palette.global.lightgray,
  },
}));
